module.exports = __webpack_public_path__ + "static/media/iconApprovals.cd55b144.svg";